import React, { useEffect, useState, useRef } from "react";
import { getParameterByName } from "../../utils/siteUtils";
import { injectScript } from "../../utils";
import api from "../../utils/api";
import config from "../../temp/config";
import { selectUserState } from "../../selectors/application";
import { connect } from "react-redux";
import { getApiError } from "../../services/siteService";
import PrimaryButton from "../../elements/primary-button";
import "./style.scss";

const containerId = `arvato-${Math.random()
  .toString(16)
  .toString(16)
  .substr(2)}`;
const PaymentWidget = ({ fields, user, match }) => {
  const { arvatoOptions, saveCtaName, saveColorScheme, saveIconName, cancelCtaName, cancelColorScheme, cancelIconName } = fields;
  const { scriptUrl, tokenizationServiceUrl, cssUrl, mandateConfirmationText, paymentMethods } = arvatoOptions.fields;
  const arv = useRef();
  const [serverError, setServerError] = useState(null);
  const [performPayout, setPerformPayout] = useState(null);
  const [securityToken, setSecurityToken] = useState(null);
  const [instrumentSaved, setInstrumentSaved] = useState(null);
  const [countryCode, setCountryCode] = useState(null);
  const [culture, setCulture] = useState(null);

  useEffect(() => {
    setPerformPayout(getParameterByName("performPayout", window.location.href)?.match(/true/i) ? true : false);
    getParameterByName("instrumentToken", window.location.href) && setInstrumentSaved(true);
    const _countryCode = getParameterByName("countryCode", window.location.href);
    setCountryCode(_countryCode || "EN");
    const _culture = getParameterByName("culture", window.location.href);
    setCulture(_culture || "en-UK");
  }, []);

  useEffect(() => {
    const token = getParameterByName("token", window.location.href);
    token && setSecurityToken(token);
  }, []);

  console.log("performPayout, securityToken", performPayout, securityToken);

  useEffect(() => {
    if (performPayout !== null && securityToken !== null && countryCode !== null && culture != null)
      init().catch(ex => {
        getApiError(ex.code).then(error => {
          setServerError(error.body.value);
        });
      });
  }, [performPayout, securityToken, countryCode, culture]);

  const init = async () => {
    if (!global.Arvato) {
      await injectScript(scriptUrl.value);
    }
    const headers =
        isNaN(fields.organizationId.value) || !match.params.lang.match(/^en$/)
          ? null
          : {
              headers: { organization: Number(fields.organizationId.value) }
            },
      {
        obj: { currencyCode }
      } = await api.order.payment.init(null, null, headers);

    if (!arv.current) {
      const arvatoOptions = new global.Arvato.PayNext.WidgetApiOptions();
      arvatoOptions.tokenizationServiceUrl = tokenizationServiceUrl.value;
      arvatoOptions.performPayout = performPayout;
      arvatoOptions.securityToken = securityToken;
      arvatoOptions.placeHolder = containerId;
      arvatoOptions.countryCode = countryCode; //"NL";
      arvatoOptions.currencyCode = currencyCode; //"EUR";
      arvatoOptions.culture = culture; //"nl-NL";
      if (cssUrl.value) {
        let cssLink = cssUrl.value;
        if (!/^http?s/.test(cssLink)) {
          cssLink = `${config.sitecoreApiHost}${cssLink}`;
        }
        arvatoOptions.cssUrl = cssLink;
      }
      arvatoOptions.displayValidationErrors = true;
      arvatoOptions.paymentMethods = paymentMethods.length > 0 ? paymentMethods.map(pm => pm.fields.phrase.value).join(",") : "*";
      arvatoOptions.mandateConfirmationText = mandateConfirmationText.value || "";
      arvatoOptions.clearFrameAfterSuccessfulPayment = false;
      arvatoOptions.successCallback = successCallback;
      arvatoOptions.errorCallback = errorCallback;
      arvatoOptions.frameWidth = 600;
      arvatoOptions.frameHeight = 360;
      arvatoOptions.renderErrorCallback = renderErrorCallback;
      arvatoOptions.unifiedPaymentMethodLogos = true;
      arvatoOptions.enforcePaymentMethodsOrder = true;
      //optional
      // arvatoOptions.firstName = "";
      // arvatoOptions.lastName = "";
      // arvatoOptions.amount = 0;

      //todo = not implemented yet
      // arvatoOptions.timeOut = 3000;
      // arvatoOptions.showCVCHint = false;
      // arvatoOptions.busyIndicator = "";
      arvatoOptions.renderSuccessCallback = renderSuccessCallback;
      arvatoOptions.onWidgetContentResized = resizeCallback; // this will be executed after the widget sends a resize notification
      arvatoOptions.automaticParentResize = true; //when widget content size is changed
      // arvatoOptions.DisableIntroductionText = true;
      console.log(arvatoOptions);
      const arvInstance = new global.Arvato.PayNext.WidgetApi(arvatoOptions);
      arvInstance.render();
      arv.current = arvInstance;
    } else {
      arv.current.options.amount = 0;
      arv.current.render();
    }
  };
  const successCallback = async ({ PaymentToken }) => {
    window.location.search = `?instrumentToken=${PaymentToken}`;
  };
  const errorCallback = () => {
    window.location.search = `?error=true`;
  };
  const renderErrorCallback = () => {};
  const renderSuccessCallback = () => {};
  const resizeCallback = () => {};
  const btnPropsSave = {
    buttonText: saveCtaName.value,
    colorScheme: saveColorScheme,
    iconName: saveIconName,
    callback: () => {
      arv.current && arv.current.tokenize();
    }
  };
  const btnPropsCancel = {
    buttonText: cancelCtaName.value,
    colorScheme: cancelColorScheme,
    iconName: cancelIconName,
    callback: () => {
      window.location.search = `?cancel=true`;
    }
  };
  if (instrumentSaved) return null;
  return (
    <div className="payment-widget">
      <div className="arvato-container">
        <div id={containerId} />
      </div>
      {serverError && <div className="failed-message" dangerouslySetInnerHTML={{ __html: serverError }} />}
      <div className="cta-container">
        <div className="cta-wrapper cancel">{btnPropsCancel && <PrimaryButton {...btnPropsCancel} />}</div>
        <div className="cta-wrapper save">{btnPropsSave && <PrimaryButton {...btnPropsSave} />}</div>
      </div>
    </div>
  );
};
const mapStateToProps = state => ({
  user: selectUserState(state)
});
export default connect(mapStateToProps)(PaymentWidget);
